import createIcon from '../../createIcon';

/**
 * @component @name AppsOutage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxMEg2VjZIMlYxMFpNOCAyMkgxMlYxOEg4VjIyWk0yIDIySDZWMThIMlYyMlpNMiAxNkg2VjEySDJWMTZaTTggMTZIMTJWMTJIOFYxNlpNMTQgMjJIMThWMThIMTRWMjJaTTE3IDJDMTQuMjQgMiAxMiA0LjI0IDEyIDdDMTIgOS43NiAxNC4yNCAxMiAxNyAxMkMxOS43NiAxMiAyMiA5Ljc2IDIyIDdDMjIgNC4yNCAxOS43NiAyIDE3IDJaTTE3LjUgMTBIMTYuNVY5SDE3LjVWMTBaTTE3LjUgOEgxNi41VjRIMTcuNVY4Wk0xNCAxNkgxOFYxMy45M0MxNy42NyAxMy45OCAxNy4zNCAxNCAxNyAxNEMxNS45MyAxNCAxNC45MSAxMy43NiAxNCAxMy4zMlYxNlpNOCA2VjEwSDEwLjY4QzEwLjI0IDkuMDkgMTAgOC4wNyAxMCA3QzEwIDYuNjYgMTAuMDIgNi4zMyAxMC4wNyA2SDhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AppsOutage = createIcon('AppsOutage', [
  [
    'path',
    {
      d: 'M2 10H6V6H2V10ZM8 22H12V18H8V22ZM2 22H6V18H2V22ZM2 16H6V12H2V16ZM8 16H12V12H8V16ZM14 22H18V18H14V22ZM17 2C14.24 2 12 4.24 12 7C12 9.76 14.24 12 17 12C19.76 12 22 9.76 22 7C22 4.24 19.76 2 17 2ZM17.5 10H16.5V9H17.5V10ZM17.5 8H16.5V4H17.5V8ZM14 16H18V13.93C17.67 13.98 17.34 14 17 14C15.93 14 14.91 13.76 14 13.32V16ZM8 6V10H10.68C10.24 9.09 10 8.07 10 7C10 6.66 10.02 6.33 10.07 6H8Z',
      key: '13gb4w',
    },
  ],
]);

export default AppsOutage;
